module.exports = __webpack_public_path__ + "static/media/3.3bfb88c0.jpg";